import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'persons',
    component: Children,

    children: [
      {
        path: '',
        name: 'persons',
        component: () => import('../pages/PersonsPage.vue')
      },

      {
        path: 'create',
        name: 'persons.create',
        component: () => import('../pages/PersonCreatePage.vue')
      },

      {
        path: ':id',
        name: 'persons.show',
        component: () => import('../pages/PersonEditPage.vue'),
        props: route => ({
          id: Number(route.params.id)
        })
      }
    ]
  }
];

export default routes;
